import { Components, Theme } from "@mui/material/styles";

const MuiDivider: Components<Theme>["MuiDivider"] = {
  styleOverrides: {
    root: {
      borderColor: "rgba(0, 0, 0, 0.5)",
      borderWidth: 1,
    },
  },
};

export default MuiDivider;
